import setBuilder from '../../../../../Template/config/components/selection/SetBuilder'
import setBuilderToolbar from './setBuilderToolbar'


export default  {
    ...setBuilder,
    setBuilderToolbar
}


// WEBPACK FOOTER //
// ./src/app/configuration/Discover/config/components/selection/SetBuilder/index.js